/* aa-contact.js — the Contact form's validation (PLAN.md I1.5, Figma `375:3654`)
 *
 * Name, email and message are required. On a send with mistakes nothing is submitted: a summary
 * shows above the fields, each failing field turns red with its own message under it, and focus
 * goes to the first of them. What was typed is kept. A field's message clears as soon as the field
 * is put right, and the summary goes with the last one.
 *
 * Every message is rendered by Liquid, already translated; this file only shows and hides them.
 * The browser's own validation bubbles are switched off here, not in the markup, so a visitor
 * without this script still gets them from the fields' `required` attributes.
 */

(function () {
  'use strict';

  // A full address: something, an @, something, a dot, something. The browser's own `type=email`
  // check accepts "anna@clinic", which is the mistake the design's error state shows.
  const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const rules = {
    name: (value) => value.trim() !== '',
    email: (value) => EMAIL.test(value.trim()),
    message: (value) => value.trim() !== '',
  };

  document.querySelectorAll('.aa-contact__form').forEach((form) => {
    if (form.dataset.aaBound === 'true') return;
    form.dataset.aaBound = 'true';

    const summary = form.querySelector('[data-aa-contact-summary]');
    const summaryText = form.querySelector('[data-aa-contact-summary-text]');
    const fields = Array.prototype.map.call(form.querySelectorAll('[data-aa-field]'), (wrap) => ({
      rule: rules[wrap.dataset.aaField],
      input: wrap.querySelector('.aa-contact__input'),
      error: wrap.querySelector('.aa-contact__error'),
    }));
    if (!summary || fields.length === 0) return;

    form.noValidate = true;

    const check = (field) => {
      const valid = field.rule(field.input.value);
      field.error.hidden = valid;
      if (valid) field.input.removeAttribute('aria-invalid');
      else field.input.setAttribute('aria-invalid', 'true');
      return valid;
    };

    const failing = () => fields.filter((field) => field.input.getAttribute('aria-invalid') === 'true');

    form.addEventListener('submit', (event) => {
      const bad = fields.filter((field) => !check(field));
      if (bad.length === 0) {
        const button = form.querySelector('.aa-contact__submit');
        if (button) button.setAttribute('aria-busy', 'true');
        return;
      }
      event.preventDefault();
      // The summary may still hold a message Shopify sent back; ours replaces it.
      if (summaryText && summaryText.dataset.text) summaryText.textContent = summaryText.dataset.text;
      summary.hidden = false;
      bad[0].input.focus();
    });

    // Once a field has been marked, it is re-checked as it is corrected, not only on the next send.
    fields.forEach((field) => {
      field.input.addEventListener('input', () => {
        if (field.input.getAttribute('aria-invalid') !== 'true') return;
        check(field);
        if (failing().length === 0) summary.hidden = true;
      });
    });
  });
})();
